export const SaveIcon = ({ ...svgProps }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width="14"
      height="14"
      {...svgProps}
    >
      <path
        data-name="Shape"
        d="M12.251 0H1.69A1.692 1.692 0 0 0 0 1.689V16.31A1.692 1.692 0 0 0 1.69 18h14.621A1.692 1.692 0 0 0 18 16.31V5.747L12.251 0zM5.56 9.056h3.4a2.537 2.537 0 0 0 2.54-2.534V1.689h.054l4.757 4.758v9.863H1.69V1.689h1.335v4.833A2.538 2.538 0 0 0 5.56 9.056zm0-1.69a.846.846 0 0 1-.845-.844V1.689h5.092v4.833a.845.845 0 0 1-.844.844zM8 2.978a.846.846 0 0 0-.845.844v1.01a.845.845 0 1 0 1.689 0V3.823A.845.845 0 0 0 8 2.978z"
        fill="#302d2c"
      />
    </svg>
  );
};
